import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initials',
    standalone: true,
})
export class InitialsPipe implements PipeTransform {
  transform(displayName: string): string {
    if (typeof displayName !== 'string') return ''
    const initials = displayName.split(' ').filter(n => !!n && n[0] !== '(')
    const first = initials[0]
    const last = initials[initials.length - 1]
    return `${ first ? first[0] : '' }${ last ? last[0] : ''}`
  }
}
